import React from 'react';
import './CheckoutHeader.scss';

const CheckoutHeader = props => {
    const { logo, pageTitle, supportEmail, className } = props;
    const dealsKart = logo && logo.indexOf('dealskart') > -1 || false;
    const imgStyle = { height: dealsKart ? '22px' : '34px' };
    return (
        <div className={`${className} checkout-header col-lg-12 col-md-12 col-sm-12`}>
            {logo && <picture className="logo"><a title={pageTitle} href="/"><img src={logo} alt={pageTitle || ''} style={imgStyle} className="headerLogo" /></a></picture>}
            {pageTitle && <div className="title fs16 text-color-white text-uppercase">{pageTitle}</div>}
            {supportEmail && <a className="support-link text-color-white fs16 fsp14" href="mailto:support@lenskart.com">{supportEmail}</a>}
        </div>
    );
};
export default CheckoutHeader;
